export default {
    path: 'collection',
    component: () => import('../Collection.vue'),
    children: [
        {
            path: '',
            name: 'Nhóm sản phẩm',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo nhóm sản phẩm',
            component: () => import('../cu/CU.vue')
        },
        {
            path: 'cu/:id',
            name: 'Chi tiết nhóm sản phẩm',
            component: () => import('../cu/CU.vue')
        },
    ],
};